import { OpportunitySheetType, useOpportunityOverlayState } from './opportunity-state';
import DeleteOpportunityDialog from './widgets/DeleteOpportunityDialog';
import OpportunityViewDetailsSheet from './widgets/OpportunityViewDetailsSheet';

const OpportunityOverlays = () => {
    const { opportunityOverlayState, closeAllOverlays, openDeleteOpportunityDialog, closeDeleteOpportunityDialog } =
        useOpportunityOverlayState();

    return (
        <>
            {opportunityOverlayState.sheetType === OpportunitySheetType.VIEW &&
                opportunityOverlayState.opportunityGuid && (
                    <OpportunityViewDetailsSheet
                        open
                        opportunityGuid={opportunityOverlayState.opportunityGuid}
                        onOpenChange={() => closeAllOverlays()}
                        onOpenDeleteDialog={() =>
                            openDeleteOpportunityDialog(opportunityOverlayState.opportunityGuid as string)
                        }
                    />
                )}
            {opportunityOverlayState.deleteOpportunityGuid && (
                <DeleteOpportunityDialog
                    open
                    opportunityGuid={opportunityOverlayState.deleteOpportunityGuid}
                    onOpenChange={() => closeAllOverlays()}
                    onCancel={() => closeDeleteOpportunityDialog()}
                />
            )}
        </>
    );
};

export default OpportunityOverlays;
